import * as React from 'react'
import { DataManagerContext, type IDataManagerContext } from 'components/common/data-manager/data-context'

const useDataManager = (): IDataManagerContext => {
  return React.useContext(DataManagerContext)
}

export default useDataManager
